import React, { useEffect, useState } from "react";
import { Badge, DefaultButton } from "../../../../../UI toolkit/Button/Button";
import { Modal } from "../../../../../UI toolkit/Modal/Modal";
import { H1, H5, H6, P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_left_icon from "../../../../../assets/images/ic-left-arrow.svg";
import { connect } from "react-redux";
import moment from "moment";

import {
  capitalizeFirstLetter,
  formatLargeNumber,
} from "../../../../../utils/specialFunctions";
import { P2PModalStyle } from "./UserP2P.styled";
import { ToggleButton } from "../../../../../UI toolkit/Input/Input";
import { updateAdStatus } from "../../../../../store/Actions/P2PActions";

const UpdateAdStatusModal = ({
  width,
  border,
  closeModalCallback,
  ad,
  user,
  updateAdStatusAction,
  adStatus,
  setAdStatus,
}) => {
  const [isActive, setIsActive] = useState(ad ? ad.is_active : false);

  const handleToggle = () => {
    // Toggle the state
    const newStatus = !isActive;
    setIsActive(newStatus);

    // Call the action with the new status
    updateAdStatusAction(ad.id, newStatus, (response) => {
      // Optional callback when API call is successful
      console.log("Ad status updated successfully", response);
      // Close the modal or handle success as needed
      // closeModalCallback(); // Uncomment if you want to close modal after success
    });
  };

  return (
    <div>
      <Modal width={width} border={border} callback={closeModalCallback}>
        {/* <pre> ffffjfj {JSON.stringify(ad, null, 2)}</pre> */}
        {ad ? (
          <P2PModalStyle>
            <div className="-mx-8">
              <div className="flex items-center justify-between px-6 py-3 border-bottom bg-white">
                <div className="flex items-center">
                  <div>
                    <h1>{adStatus ? adStatus.toString() : adStatus}ddhdhd</h1>
                    <H6
                      color={"#112E46"}
                      className="text-center"
                      fontWeight="700"
                    >
                      Update Ad Status
                    </H6>
                  </div>
                </div>

                <div className=""></div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="13px"
                      color={"#374072"}
                      fontWeight="500"
                    >
                      Ad activity
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12 flex justify-end items-center">
                  <ToggleButton
                    toggleId={"update-status"}
                    checked={isActive}
                    onChange={handleToggle}
                  />

                  <P className="ml-2">Offline</P>
                </div>
              </div>
            </div>
          </P2PModalStyle>
        ) : (
          <P fontSize="13px" color={"#374072"} fontWeight="500">
            Loading.....
          </P>
        )}
      </Modal>
    </div>
  );
};

// Redux store mapstatetoprops and mapdispatchtoprops
const mapStateToProps = (state) => {
  return {
    loading: state.verification.loading,
    error: state.verification.error,
  };
};

// Link Actions to components
const mapDispatchToProps = (dispatch) => {
  return {
    updateAdStatusAction: (ad_id, state, successCallback) =>
      dispatch(updateAdStatus(ad_id, state, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateAdStatusModal);
